(() => {
  const SELECTORS = {
    header: '[data-qh-header]',
    menuToggle: '[data-qh-menu-toggle]',
    navigation: '[data-qh-navigation]',
    collection: '[data-qh-collection]'
  };

  function initHeader(scope = document) {
    const header = scope.querySelector(SELECTORS.header) || document.querySelector(SELECTORS.header);
    if (!header || header.dataset.initialized === 'true') return;
    header.dataset.initialized = 'true';

    const toggle = header.querySelector(SELECTORS.menuToggle);
    const navigation = header.querySelector(SELECTORS.navigation);
    const setScrolled = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    const closeMenu = () => {
      if (!toggle || !navigation) return;
      toggle.setAttribute('aria-expanded', 'false');
      navigation.classList.remove('is-open');
      document.body.classList.remove('qh-menu-open');
    };

    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });

    if (toggle && navigation) {
      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        navigation.classList.toggle('is-open', !isOpen);
        document.body.classList.toggle('qh-menu-open', !isOpen);
      });
      navigation.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
      window.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu();
      });
    }
  }

  function initCollection(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const filters = section.querySelectorAll('[data-qh-filter]');
    const cards = section.querySelectorAll('[data-qh-card]');
    const dialog = section.querySelector('[data-qh-dialog]');

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        filters.forEach((item) => item.classList.remove('is-active'));
        filter.classList.add('is-active');
        const selected = filter.dataset.qhFilter;
        cards.forEach((card) => {
          card.hidden = selected !== 'all' && card.dataset.category !== selected;
        });
      });
    });

    if (!dialog || typeof dialog.showModal !== 'function') return;
    const title = dialog.querySelector('[data-qh-dialog-title]');
    const copy = dialog.querySelector('[data-qh-dialog-copy]');
    const close = dialog.querySelector('[data-qh-dialog-close]');

    section.querySelectorAll('[data-qh-concept]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        title.textContent = trigger.dataset.title || '';
        copy.textContent = trigger.dataset.description || '';
        dialog.showModal();
      });
    });

    close?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      const rect = dialog.getBoundingClientRect();
      const isInside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!isInside) dialog.close();
    });
  }

  function init(scope = document) {
    initHeader(scope);
    scope.querySelectorAll(SELECTORS.collection).forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
